const curpIsValid = (value) => {
  const validator = /[A-Z]{4}[0-9]{2}[0-1][0-9][0-3][0-9][A-Z0-9]{8}/;
  const valueIsValid = validator.test(value);
  return valueIsValid;
};

export default curpIsValid;
